import React, { useEffect, useState } from "react";
import axios from "../../axios";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import Overlay from "../../components/Overlay";
import {
    DashboardContainerData,
    DashboardWrapper,
    ProfileDetailForm,
} from "./CMSElement";

import { subadminAccessChange } from "../../utils/functions";

const PrivacyPolicyData = ({ setUsers }) => {
    const navigate = useNavigate();

    //  HTML STRING STATE
    const [allFaqData, setAllFaqData] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    // FETCH ON LOAD
    useEffect(() => {
        fetchTermsAndConditions();
    }, []);

    const fetchTermsAndConditions = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(
                "https://api.jobdashflash.com/api/user/privacy-policy"
            );

            // DIRECT HTML STRING
            setAllFaqData(response?.data?.data || "");
        } catch (error) {
            handleErrorResponse(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleErrorResponse = (error) => {
        const status = error?.response?.status;
        const message =
            error?.response?.data?.message || "Something went wrong";

        if (status === 901) {
            subadminAccessChange(navigate);
            toast.error(message);
        } else if (status === 419) {
            localStorage.clear();
            Cookies.remove("showProfileSidebar");
            setUsers("");
            toast.error(message);
            navigate("/");
        } else {
            toast.error(message);
        }
    };

    return (
        <>
            <DashboardContainerData>
                <DashboardWrapper>
                    <ProfileDetailForm>

                        {/* LOADING */}
                        {isLoading && <p>Loading...</p>}

                        {/* NO DATA */}
                        {!isLoading && !allFaqData && (
                            <p>No data found</p>
                        )}

                        {/* SHOW HTML */}
                        {!isLoading && allFaqData && (
                            <div
                                className="terms-html-content"
                                dangerouslySetInnerHTML={{
                                    __html: allFaqData,
                                }}
                            />
                        )}

                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainerData>

            {isLoading && <Overlay />}
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    setUsers: (updatedValue) => {
        dispatch({
            type: actionTypes.UPDATE_USER,
            updatedUser: updatedValue,
        });
    },
});

export default connect(null, mapDispatchToProps)(PrivacyPolicyData);
